<template>
  <div :class="`text-${field.textAlign}`">
    <span class="inline-flex items-center">
      <span v-if="field.viewable && field.value">
        <RelationPeek
          v-if="field.peekable && field.hasFieldsToPeekAt"
          :resource-name="field.resourceName"
          :resource-id="field.belongsToId"
          :resource="resource"
        >
          <Link
            @click.stop
            :href="
              $url(`/resources/${field.resourceName}/${field.belongsToId}`)
            "
            class="link-default"
          >
            {{ field.value }}
          </Link>
        </RelationPeek>

        <Link
          v-else
          @click.stop
          :href="$url(`/resources/${field.resourceName}/${field.belongsToId}`)"
          class="link-default"
        >
          {{ field.value }}
        </Link>
      </span>
      <span v-else-if="field.value">{{ field.value }}</span>
      <span v-else>&mdash;</span>

      <CopyButton
        v-if="field.copyable && field.value"
        class="ml-1"
        @click.prevent.stop="copy"
        v-tooltip="__('Copy to clipboard')"
      />
    </span>
  </div>
</template>

<script setup>
import { useCopyValueToClipboard } from '@/mixins/CopiesToClipboard'

const props = defineProps({
  resource: { type: Object },
  resourceName: { type: String },
  field: { type: Object },
})

const { copyValueToClipboard } = useCopyValueToClipboard()
const copy = () => copyValueToClipboard(props.field.value)
</script>
